/**
 * All translations keys in this app will be prefixed with this namespace to prevent conflicts with
 * other keys of the consuming app.
 */
export const I18N_NAMESPACE = '@qmulus/ui' as const;
